export const LANGS = [
  { code: "ru", label: "RU", name: "Русский" },
  { code: "en", label: "EN", name: "English" },
  { code: "tr", label: "TR", name: "Türkçe" },
];

export const translations = {
  ru: {
    brand: "Мастер на все руки",
    nav: {
      about: "О нас",
      services: "Услуги",
      why: "Почему мы",
      portfolio: "Проекты",
      process: "Как это работает",
      contact: "Контакты",
    },
    header: { quote: "Бесплатная смета" },
    hero: {
      badge: "Ремонт · Строительство · Недвижимость",
      titleLines: ["Полный спектр решений", "по ремонту, реновации,", "строительству и недвижимости"],
      desc: "Профессиональные услуги для домов, офисов и коммерческих объектов. Надёжно, качественно и в срок — от мелкого ремонта до крупных проектов.",
      call: "Позвонить",
      quote: "Бесплатная смета",
      stats: [
        { value: "12+", label: "лет опыта" },
        { value: "850+", label: "проектов" },
        { value: "100%", label: "гарантия" },
      ],
    },
    marquee: ["Ремонт", "Реновация", "Строительство", "Сантехника", "Электрика", "Покраска", "Плитка", "Недвижимость", "Обслуживание"],
    about: {
      tag: "О компании",
      title: "Одна команда — все работы под ключ",
      p1: "«Мастер на все руки» предоставляет надёжные, качественные и комплексные решения для ремонта, реновации, строительства, обслуживания объектов и сделок с недвижимостью.",
      p2: "Мы объединяем опытных специалистов всех профилей, чтобы вы могли доверить весь проект одной команде — от первой консультации до финальной уборки. Прозрачные цены, чёткие сроки и внимание к деталям.",
      points: ["Опытные мастера всех профилей", "Работаем с жильём и коммерцией", "Прозрачная смета без скрытых платежей", "Гарантия на все виды работ"],
    },
    services: {
      tag: "Наши услуги",
      title: "Всё, что нужно вашему объекту",
      subtitle: "12 направлений услуг под одной крышей — для дома, офиса и бизнеса.",
      items: [
        { key: "repairs", title: "Ремонт и обслуживание", desc: "Быстрый и аккуратный ремонт любой сложности для дома и офиса." },
        { key: "home", title: "Ремонт квартир и домов", desc: "Комплексная реновация жилых помещений под ключ." },
        { key: "commercial", title: "Коммерческий ремонт", desc: "Офисы, магазины и коммерческие площади любой площади." },
        { key: "construction", title: "Строительство", desc: "Строительные работы от фундамента до сдачи объекта." },
        { key: "plumbing", title: "Сантехника", desc: "Монтаж, замена и ремонт сантехнических систем." },
        { key: "electrical", title: "Электрика", desc: "Безопасный монтаж и ремонт электропроводки и оборудования." },
        { key: "painting", title: "Покраска и декор", desc: "Профессиональная покраска и декоративная отделка стен." },
        { key: "flooring", title: "Полы и плитка", desc: "Укладка плитки, ламината, паркета и напольных покрытий." },
        { key: "install", title: "Монтаж мебели и техники", desc: "Сборка, установка мебели и подключение оборудования." },
        { key: "sales", title: "Продажа недвижимости", desc: "Помощь в покупке и продаже жилой и коммерческой недвижимости." },
        { key: "rentals", title: "Аренда недвижимости", desc: "Подбор и оформление аренды объектов под ваши задачи." },
        { key: "consulting", title: "Консалтинг по недвижимости", desc: "Экспертная консультация по инвестициям и сделкам." },
      ],
    },
    why: {
      tag: "Почему выбирают нас",
      title: "Причины доверять нам ваш проект",
      items: [
        { title: "Опытные специалисты", desc: "Команда проверенных мастеров с многолетним опытом." },
        { title: "Высокое качество работ", desc: "Работаем по стандартам и не идём на компромиссы." },
        { title: "Надёжность и сроки", desc: "Выполняем работы вовремя, как договорились." },
        { title: "Прозрачные цены", desc: "Честная смета без скрытых доплат." },
        { title: "Индивидуальные решения", desc: "Подход под ваши задачи и бюджет." },
        { title: "Жильё и коммерция", desc: "Работаем с любыми типами объектов." },
        { title: "Бесплатная консультация", desc: "Первичная консультация и оценка — бесплатно." },
        { title: "Фокус на клиенте", desc: "Ваша удовлетворённость — наш приоритет." },
      ],
    },
    portfolio: {
      tag: "Наши работы",
      title: "Реализованные проекты",
      subtitle: "Наведите на фото, чтобы увидеть результат «до и после».",
      before: "До",
      after: "После",
    },
    process: {
      tag: "Как это работает",
      title: "Четыре простых шага",
      steps: [
        { title: "Свяжитесь с нами", desc: "Позвоните или напишите в WhatsApp — расскажите о задаче." },
        { title: "Бесплатная консультация", desc: "Мы оценим объём работ и предложим решение." },
        { title: "Индивидуальная смета", desc: "Готовим прозрачную смету под ваш проект." },
        { title: "Выполняем профессионально", desc: "Реализуем проект качественно и в срок." },
      ],
    },
    contact: {
      tag: "Свяжитесь с нами",
      title: "Начнём ваш проект",
      subtitle: "Позвоните напрямую или отправьте заявку — ответим быстро.",
      whatsapp: "Написать в WhatsApp",
      form: {
        name: "Полное имя",
        phone: "Номер телефона",
        email: "Email",
        service: "Тип услуги",
        servicePlaceholder: "Выберите услугу",
        details: "Детали проекта",
        detailsPlaceholder: "Опишите вашу задачу...",
        submit: "Отправить заявку",
        note: "После отправки откроется WhatsApp с вашим сообщением.",
      },
    },
    footer: {
      desc: "Ремонт, реновация, строительство и услуги недвижимости для дома, офиса и бизнеса.",
      nav: "Навигация",
      contacts: "Контакты",
      social: "Соцсети",
      soon: "Скоро",
      rights: "Все права защищены.",
    },
    whatsappMsg: {
      intro: "Здравствуйте! Хочу оставить заявку на сайте «Мастер на все руки».",
      name: "Имя",
      phone: "Телефон",
      email: "Email",
      service: "Услуга",
      details: "Детали",
    },
  },

  en: {
    brand: "Мастер на все руки",
    nav: { about: "About", services: "Services", why: "Why us", portfolio: "Projects", process: "How it works", contact: "Contact" },
    header: { quote: "Free Quote" },
    hero: {
      badge: "Repair · Construction · Real Estate",
      titleLines: ["Complete repair, renovation,", "construction and real estate", "solutions under one roof"],
      desc: "Professional services for homes, offices and commercial properties. Reliable, high-quality and on time — from small repairs to major projects.",
      call: "Call Us",
      quote: "Get a Free Quote",
      stats: [
        { value: "12+", label: "years experience" },
        { value: "850+", label: "projects done" },
        { value: "100%", label: "guaranteed" },
      ],
    },
    marquee: ["Repair", "Renovation", "Construction", "Plumbing", "Electrical", "Painting", "Tiling", "Real Estate", "Maintenance"],
    about: {
      tag: "About us",
      title: "One team — every job, turnkey",
      p1: "“Master of all trades” delivers dependable, high-quality and comprehensive solutions for repair, renovation, construction, property maintenance and real estate needs.",
      p2: "We bring together experienced specialists across every trade, so you can trust your entire project to a single team — from the first consultation to the final clean-up. Transparent pricing, clear timelines and attention to detail.",
      points: ["Experienced multi-trade craftsmen", "Residential and commercial work", "Transparent quotes, no hidden fees", "Workmanship guaranteed"],
    },
    services: {
      tag: "Our services",
      title: "Everything your property needs",
      subtitle: "12 service lines under one roof — for home, office and business.",
      items: [
        { key: "repairs", title: "Repairs & Maintenance", desc: "Fast, tidy repairs of any complexity for home and office." },
        { key: "home", title: "Home Renovation", desc: "Complete turnkey renovation of residential spaces." },
        { key: "commercial", title: "Commercial Renovation", desc: "Offices, shops and commercial spaces of any size." },
        { key: "construction", title: "Construction", desc: "Construction works from foundation to handover." },
        { key: "plumbing", title: "Plumbing", desc: "Installation, replacement and repair of plumbing systems." },
        { key: "electrical", title: "Electrical Services", desc: "Safe installation and repair of wiring and equipment." },
        { key: "painting", title: "Painting & Decoration", desc: "Professional painting and decorative wall finishes." },
        { key: "flooring", title: "Flooring & Tiling", desc: "Laying tiles, laminate, parquet and floor coverings." },
        { key: "install", title: "Furniture & Equipment Install", desc: "Assembly, installation of furniture and equipment hookup." },
        { key: "sales", title: "Real Estate Sales", desc: "Help buying and selling residential and commercial property." },
        { key: "rentals", title: "Property Rentals", desc: "Finding and arranging rentals tailored to your needs." },
        { key: "consulting", title: "Real Estate Consulting", desc: "Expert advice on investment and property deals." },
      ],
    },
    why: {
      tag: "Why choose us",
      title: "Reasons to trust us with your project",
      items: [
        { title: "Experienced professionals", desc: "A team of vetted craftsmen with years of experience." },
        { title: "High-quality workmanship", desc: "We work to standards and never cut corners." },
        { title: "Reliable & on time", desc: "We deliver the work when we agreed to." },
        { title: "Transparent pricing", desc: "Honest quotes with no hidden charges." },
        { title: "Customized solutions", desc: "Tailored to your needs and budget." },
        { title: "Residential & commercial", desc: "We work with any type of property." },
        { title: "Free consultation", desc: "Initial consultation and estimate — free." },
        { title: "Customer focused", desc: "Your satisfaction is our priority." },
      ],
    },
    portfolio: {
      tag: "Our work",
      title: "Completed projects",
      subtitle: "Hover over a photo to reveal the before-and-after result.",
      before: "Before",
      after: "After",
    },
    process: {
      tag: "How it works",
      title: "Four simple steps",
      steps: [
        { title: "Contact us", desc: "Call or message us on WhatsApp — tell us about the job." },
        { title: "Free consultation", desc: "We assess the scope and propose a solution." },
        { title: "Customized quote", desc: "We prepare a transparent quote for your project." },
        { title: "We deliver professionally", desc: "We complete the project with quality, on time." },
      ],
    },
    contact: {
      tag: "Get in touch",
      title: "Let's start your project",
      subtitle: "Call us directly or send a request — we reply fast.",
      whatsapp: "Message on WhatsApp",
      form: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Email Address",
        service: "Type of Service",
        servicePlaceholder: "Select a service",
        details: "Project Details",
        detailsPlaceholder: "Describe your project...",
        submit: "Send Request",
        note: "After sending, WhatsApp will open with your message.",
      },
    },
    footer: {
      desc: "Repair, renovation, construction and real estate services for home, office and business.",
      nav: "Navigation",
      contacts: "Contacts",
      social: "Social",
      soon: "Soon",
      rights: "All rights reserved.",
    },
    whatsappMsg: {
      intro: "Hello! I'd like to submit a request from the “Master of all trades” website.",
      name: "Name",
      phone: "Phone",
      email: "Email",
      service: "Service",
      details: "Details",
    },
  },

  tr: {
    brand: "Мастер на все руки",
    nav: { about: "Hakkımızda", services: "Hizmetler", why: "Neden biz", portfolio: "Projeler", process: "Nasıl çalışır", contact: "İletişim" },
    header: { quote: "Ücretsiz Teklif" },
    hero: {
      badge: "Tamir · İnşaat · Emlak",
      titleLines: ["Tamir, tadilat, inşaat ve", "emlak için eksiksiz", "çözümler tek çatı altında"],
      desc: "Evler, ofisler ve ticari mülkler için profesyonel hizmetler. Güvenilir, yüksek kaliteli ve zamanında — küçük tamiratlardan büyük projelere.",
      call: "Bizi Arayın",
      quote: "Ücretsiz Teklif Alın",
      stats: [
        { value: "12+", label: "yıl tecrübe" },
        { value: "850+", label: "tamamlanan proje" },
        { value: "100%", label: "garanti" },
      ],
    },
    marquee: ["Tamir", "Tadilat", "İnşaat", "Tesisat", "Elektrik", "Boya", "Fayans", "Emlak", "Bakım"],
    about: {
      tag: "Hakkımızda",
      title: "Tek ekip — her iş, anahtar teslim",
      p1: "“Her işin ustası” tamir, tadilat, inşaat, mülk bakımı ve emlak ihtiyaçları için güvenilir, yüksek kaliteli ve kapsamlı çözümler sunar.",
      p2: "Her branştan deneyimli uzmanları bir araya getiriyoruz; böylece projenizin tamamını tek bir ekibe emanet edebilirsiniz — ilk görüşmeden son temizliğe kadar. Şeffaf fiyatlandırma, net süreler ve detaylara özen.",
      points: ["Deneyimli çok yönlü ustalar", "Konut ve ticari işler", "Şeffaf teklif, gizli ücret yok", "İşçilik garantili"],
    },
    services: {
      tag: "Hizmetlerimiz",
      title: "Mülkünüzün ihtiyacı olan her şey",
      subtitle: "Tek çatı altında 12 hizmet alanı — ev, ofis ve işletme için.",
      items: [
        { key: "repairs", title: "Tamir ve Bakım", desc: "Ev ve ofis için her zorlukta hızlı, temiz tamirat." },
        { key: "home", title: "Ev Tadilatı", desc: "Konutların anahtar teslim komple tadilatı." },
        { key: "commercial", title: "Ticari Tadilat", desc: "Her ölçüde ofis, mağaza ve ticari alanlar." },
        { key: "construction", title: "İnşaat", desc: "Temelden teslime kadar inşaat işleri." },
        { key: "plumbing", title: "Tesisat", desc: "Tesisat sistemlerinin montajı, değişimi ve tamiri." },
        { key: "electrical", title: "Elektrik Hizmetleri", desc: "Kablolama ve ekipmanların güvenli montaj ve tamiri." },
        { key: "painting", title: "Boya ve Dekorasyon", desc: "Profesyonel boya ve dekoratif duvar uygulamaları." },
        { key: "flooring", title: "Zemin ve Fayans", desc: "Fayans, laminat, parke ve zemin kaplaması döşeme." },
        { key: "install", title: "Mobilya ve Ekipman Montajı", desc: "Mobilya kurulumu ve ekipman bağlantısı." },
        { key: "sales", title: "Emlak Satışı", desc: "Konut ve ticari mülk alım-satımında destek." },
        { key: "rentals", title: "Mülk Kiralama", desc: "İhtiyaçlarınıza göre kiralama bulma ve düzenleme." },
        { key: "consulting", title: "Emlak Danışmanlığı", desc: "Yatırım ve mülk işlemlerinde uzman danışmanlık." },
      ],
    },
    why: {
      tag: "Neden biz",
      title: "Projenizi bize emanet etme nedenleri",
      items: [
        { title: "Deneyimli profesyoneller", desc: "Yılların tecrübesine sahip güvenilir ustalar ekibi." },
        { title: "Yüksek kaliteli işçilik", desc: "Standartlara uyar, taviz vermeyiz." },
        { title: "Güvenilir ve zamanında", desc: "İşi anlaştığımız zamanda teslim ederiz." },
        { title: "Şeffaf fiyatlandırma", desc: "Gizli ücretsiz dürüst teklifler." },
        { title: "Özel çözümler", desc: "İhtiyaç ve bütçenize göre uyarlanmış." },
        { title: "Konut ve ticari", desc: "Her tür mülkle çalışırız." },
        { title: "Ücretsiz danışma", desc: "İlk görüşme ve keşif — ücretsiz." },
        { title: "Müşteri odaklı", desc: "Memnuniyetiniz önceliğimizdir." },
      ],
    },
    portfolio: {
      tag: "Çalışmalarımız",
      title: "Tamamlanan projeler",
      subtitle: "Önce-sonra sonucu görmek için fotoğrafın üzerine gelin.",
      before: "Önce",
      after: "Sonra",
    },
    process: {
      tag: "Nasıl çalışır",
      title: "Dört basit adım",
      steps: [
        { title: "Bize ulaşın", desc: "Arayın veya WhatsApp'tan yazın — işi bize anlatın." },
        { title: "Ücretsiz danışma", desc: "Kapsamı değerlendirir, çözüm sunarız." },
        { title: "Özel teklif", desc: "Projeniz için şeffaf bir teklif hazırlarız." },
        { title: "Profesyonelce tamamlarız", desc: "Projeyi kaliteli ve zamanında bitiririz." },
      ],
    },
    contact: {
      tag: "İletişime geçin",
      title: "Projenize başlayalım",
      subtitle: "Doğrudan arayın veya talep gönderin — hızlıca yanıtlıyoruz.",
      whatsapp: "WhatsApp'tan yazın",
      form: {
        name: "Ad Soyad",
        phone: "Telefon Numarası",
        email: "E-posta Adresi",
        service: "Hizmet Türü",
        servicePlaceholder: "Bir hizmet seçin",
        details: "Proje Detayları",
        detailsPlaceholder: "Projenizi anlatın...",
        submit: "Talep Gönder",
        note: "Gönderdikten sonra WhatsApp mesajınızla açılacak.",
      },
    },
    footer: {
      desc: "Ev, ofis ve işletme için tamir, tadilat, inşaat ve emlak hizmetleri.",
      nav: "Gezinme",
      contacts: "İletişim",
      social: "Sosyal",
      soon: "Yakında",
      rights: "Tüm hakları saklıdır.",
    },
    whatsappMsg: {
      intro: "Merhaba! “Her işin ustası” web sitesinden bir talep göndermek istiyorum.",
      name: "Ad",
      phone: "Telefon",
      email: "E-posta",
      service: "Hizmet",
      details: "Detaylar",
    },
  },
};
